import FIPModel from "../Models/FIPModel";
import { AuthenticationState } from "./Reducer/authenticationReducer";

export const getFIP = (fips: FIPModel[]) => ({
  type: "ADD_FIP",
  payload: {
    fips,
  },
});

export const saveToken = (authenticationState: AuthenticationState) => ({
  type: "SAVE_TOKEN",
  payload: {
    ...authenticationState,
  },
});

export const startLoader = () => ({
  type: "START_SEARCH",
});

export const pauseLoader = () => ({
  type: "FINISH_SEARCH",
});

export const userInformation = (user: any) => ({
  type: "STORE_USER",
  payload: {
    user,
  },
});
